import { logger } from './constants';
import { getGTMId, formatDate } from './tag-manager-utils';

window.dataLayer = window.dataLayer || [];

export const TagManagerLegacy = {
  isNativeJS: false,

  // Fill DL functions
  fillDatasFromPeriod: function(obj, period) {
    if (period.dayInStr &&
      period.monthInStr &&
      period.yearInStr) {
      var dayInStr = period.dayInStr;
      var monthInStr = period.monthInStr;
      var yearInStr = period.yearInStr;
      obj['searchcriteriaarrivaldate'] = formatDate(dayInStr, monthInStr, yearInStr);
    }
    if (period.dayOutStr &&
      period.monthOutStr &&
      period.yearOutStr) {
      var dayOutStr = period.dayOutStr;
      var monthOutStr = period.monthOutStr;
      var yearOutStr = period.yearOutStr;
      obj['searchcriteriadeparturedate'] = formatDate(dayOutStr, monthOutStr, yearOutStr);
    }
    obj['datefieldempty'] = obj['searchcriteriaarrivaldate'] == null && obj['searchcriteriadeparturedate'] == null;
  },
  fillDatasFromRoomCriteria: function(obj, roomsCriteria) {
    for (var i = 0; i < roomsCriteria.length; i++) {
      var entry = null;
      if (obj['searchroomcriteria' + (i + 1)] == null || obj['searchroomcriteria' + (i + 1)] == undefined) {
        obj['searchroomcriteria' + (i + 1)] = {
          numberadults: 1,
          numberchildren: 0,
          childrenage1: 0,
          childrenage2: 0,
          childrenage3: 0
        };
      }
      entry = obj['searchroomcriteria' + (i + 1)];
      entry['numberadults'] = roomsCriteria[i].adultNumber;
      if (roomsCriteria[i].children) {
        entry['numberchildren'] = roomsCriteria[i].children.length;
        for (var k = roomsCriteria[i].children.length - 1; k >= 0; k--) {
          entry['childrenage' + (k + 1)] = roomsCriteria[i].children[k].age;
        }
      }
    }

    return obj;
  },
  fillDatasFromFidelityCards: function(obj, fidelityCard, fidelityCards) {
    if (fidelityCards && fidelityCards.length > 0) {
      for (var i = 0; i < fidelityCards.length; i++) {
        var fc = fidelityCards[i];
        if (fc && fc.type) {
          obj['loyaltycardtypes'].push(fc.type);
        }
      }
    } else if (fidelityCard && fidelityCard.type) {
      obj['loyaltycardtypes'].push(fidelityCard.type);
    }
    return obj;
  }
};

// Event tracking engine
(function(tm) {

  if (tm && tm.registerConfigurationEventTracking) {
    return;
  }

  var isRedirectEnable = true;

  var createTagEvent = function(confTracking, $this, fn) {

    var dataToPush = {
      event: confTracking.event,
      eventCategory: confTracking.eventCategory,
      eventAction: confTracking.eventAction,
      eventLabel: 'label not found'
    };

    if (typeof confTracking.eventLabel === 'function') {
      dataToPush.eventLabel = confTracking.eventLabel($this);
    } else {
      dataToPush.eventLabel = confTracking.eventLabel;
    }

    if (typeof confTracking.eventAction === 'function') {
      dataToPush.eventAction = confTracking.eventAction($this);
    } else {
      dataToPush.eventAction = confTracking.eventAction;
    }

    if (fn) {
      dataToPush.eventCallback = fn;
      dataToPush.eventTimeout = 1000;
    }

    return dataToPush;
  };

  var searchTagName = function (target, isRedirect) {
    var returnEl = '';

    switch (target.tagName) {
      case 'INPUT':
        returnEl = target;
        break;
      case 'SELECT':
        returnEl = target;
        break;
      case 'A':
        returnEl = target;
        break;
      case 'BUTTON':
        returnEl = isRedirect ? '' : target;
        break;
      default:
        var el = target.parentElement || target.parentNode;
        do {
          if(el.tagName == 'A' || (!isRedirect && el.tagName == 'BUTTON')) {
            returnEl = el;
            break;
          } else {
            el = el.parentElement || el.parentNode;
          }
        }
        while (el.tagName == 'A' || (!isRedirect && el.tagName == 'BUTTON'));
    }

    return returnEl;
  };

  var ctaCallBack = function(event, data) {
    var confEvents = data || {};
    var tagEvents = confEvents.tagEvents || [];
    var nbTags = tagEvents.length || 0;
    var current = 0;
    var $this = searchTagName(event.target, false);
    if ($this !== '') {
      var redirectUrl = $this.getAttribute('href') || '';
      var target = $this.getAttribute('target') || '';
      var isPreventDefault = isRedirectEnable && redirectUrl.length > 0 && $this.tagName =='A' && !(target.length > 0 && target.toLowerCase() == '_blank');
      if (isPreventDefault) {
        // href : no target _blank so we need to event.preventDefault() to complete tags
        event.preventDefault();
      }
    }

    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
      };
    }

    var redirect = function() {
      if (isPreventDefault && $this !== '' && redirectUrl.length > 0) {
        //eslint-disable-next-line no-console
        logger('redirect to ', redirectUrl);
        window.location.href = redirectUrl;
      } else {
        //eslint-disable-next-line no-console
        logger('no redirect');
      }
    };

    var countTagsAck = function(containerID) {
      var gtmId = getGTMId();
      if (containerID == gtmId) {
        current++;
        // eslint-disable-next-line no-console
        logger('tag event done - '+current+'/'+nbTags);
        if (current == nbTags) {
        // eslint-disable-next-line no-console
          logger('all tags event done');
          redirect();
        }
      }
    };

    var fncb = countTagsAck;
    var jQuery = window.jQuery3 || window.jQuery || window.$;
    if (!TagManagerLegacy.isNativeJS && jQuery) {
      $this = jQuery($this);
    }

    for (var index in tagEvents) {
      var confTagEvent = tagEvents[index];
      var tagEvent = createTagEvent(confTagEvent, $this, fncb);
      pushTag(tagEvent);
    }

  };

  var pushTag = function(d) {
    if (typeof window.google_tag_manager == 'undefined') {
      d.eventCallback(getGTMId());
    } else {
      window.dataLayer.push(d);
    }
  };

  var addListenerToElements = function(elements, conf, clazzList) {
    if(elements.length > 0) {
      for(let i =0; i < elements.length; i++) {
        // var event = conf.event || 'click';
        if (clazzList) {
          elements[i].classList.add(clazzList);
        }
        elements[i].addEventListener(conf.event || 'click', (e) => {
          ctaCallBack(e, conf);
        });
      }
    } else {
      // eslint-disable-next-line no-console
      logger('no elements to bind');
    }
  };

  function on(element, eventName, selector, fn) {
    // var element = document.querySelector(elSelector);
    element.addEventListener(eventName, function(event) {
      var possibleTargets = element.querySelectorAll(selector);
      var target = event.target;
      for (var i = 0, l = possibleTargets.length; i < l; i++) {
        var el = target;
        var p = possibleTargets[i];
        while(el && el !== element) {
          if (el === p) {
            return fn.call(p, event);
          }
          el = el.parentNode;
        }
      }
    });
  }

  let processEventTracking = function(selector, eventTracking) {
    let tags = eventTracking.tagEvents;
    // let child = eventTracking.childToBind;
    if (tags && tags.length > 0) {
      let elements = document.querySelectorAll(selector);
      if (elements.length > 0) {

        // Add binding for child element on a custom event
        if (eventTracking.childToBind) {

          for (let i=0; i<elements.length; i++) {
            let element = elements[i];
            element.classList.add('gaTrackedChild');
            on(element, eventTracking.event || 'click', eventTracking.childToBind, (e) => {
              // eslint-disable-next-line no-console
              logger('callback function on gaTrackedChild for element: ' + selector + ' ' + eventTracking.childToBind );
              ctaCallBack(e, eventTracking);
            });
          }

        } else {
          let selectorElem = document.querySelectorAll(selector);
          addListenerToElements(selectorElem, eventTracking, 'gaTrackedElement');
        }

      } else {
        // eslint-disable-next-line no-console
        logger('no element found for selector ' + selector);
      }
    } else {
      // eslint-disable-next-line no-console
      logger('no tagEvents define for event tracking ' + selector);
    }
  };

  var init = function(conf) {
    let allEvents = conf.events;
    for (let selector in allEvents) {
      const eventTracking = allEvents[selector];
      processEventTracking(selector, eventTracking);
    }
  };

  tm.registerConfigurationEventTracking = function(conf, isNativeJS) {
    TagManagerLegacy.isNativeJS = isNativeJS || false;
    if (conf) {
      init(conf);
    }
  };

})(TagManagerLegacy);
